
const state = {
  id: null,
  campaign_id: null,
  owner_id: null,
  owner_type: '',
}

export const requiredFields = [
  { key: 'campaign_id' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
